import { render, staticRenderFns } from "./approval-list.vue?vue&type=template&id=307f651e&"
import script from "./approval-list.vue?vue&type=script&lang=js&"
export * from "./approval-list.vue?vue&type=script&lang=js&"
import style0 from "./approval-list.vue?vue&type=style&index=0&id=307f651e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports